import React, { FC } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import AppHeader from "./components/Header";
import AppFooter from "./components/Footer";

export const AppLayout: FC = () => {
  return (
    <Layout className="app-layout">
      <AppHeader />
      <Layout.Content className="pt-1">
        <div className="base-container mb-1">
          <Outlet />
        </div>
        <AppFooter />
      </Layout.Content>
    </Layout>
  );
};

export default AppLayout;
